import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import Swal from "sweetalert2";
import DecryptData from "../utils/Decrypt";
import logout from "../utils/Logout";
import { GetAccess, GetRole, GetUserDetails } from "../utils/RolesandAccess";
import { HelpIcon, UserProfile } from "../assets/icons";
import { NotificationPanel } from "../components/View/NotificationPanel";

// import { GetAccess} from "../data/role";

function Navbar() {
  const [open, setOpen] = useState(false);
  function logOut() {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Log out ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Logout",
    }).then(async (result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  }

  let { UserImage, Name } = GetUserDetails();

  return (
    <nav className="bg-primary">
      <div className="py-0 lg:py-1 w-11/12  m-auto flex items-center justify-between">
        <div className="md:w-auto w-full flex justify-between">
          <NavLink
            to="/main/standard"
            className="md:cursor-pointer text-2xl 2xl:text-3xl py-2 text-white font-semibold"
          >
            MetaScroll
          </NavLink>
          <div className="text-3xl md:hidden" onClick={() => setOpen(!open)}>
            <ion-icon name={`${open ? "close" : "menu"}`}></ion-icon>
          </div>
        </div>
        <div className=" flex gap-2 items-center">
          <NotificationPanel />
          <Link to="/help">
            {" "}
            <HelpIcon />{" "}
          </Link>
          <div className="pl-3 py-1 text-left md:cursor-pointer group relative">
            <a
              href="#!"
              className="flex items-center md:pr-0 pr-5 group text-white text-xs 2xl:text-sm border-l border-white"
            >
              {UserImage ? (
                <img
                  src={UserImage}
                  alt="#"
                  className="w-7 h-7 mx-2 rounded-full bg-slate-300 object-fill"
                />
              ) : (
                <div className="w-7 h-7 mx-2 rounded-full ">
                  <UserProfile />
                </div>
              )}

              <p className=" text-white text-sm 2xl:text-sm capitalize">
                {Name || "-"}
              </p>
            </a>
            <div className="absolute z-50 top-[1.8rem] hidden group-hover:md:block hover:md:block">
              <div className="bg-white shadow-box rounded-md px-1 py-3 grid grid-cols-1 w-24">
                <div>
                  {GetAccess("admin_view") && (
                    <li className="list-none p-2 hover:bg-navhover rounded-md">
                      <Link
                        to="/admin-settings/company-info"
                        className="text-xs 2xl:text-sm"
                        // onClick={logOut}
                      >
                        Settings
                      </Link>
                    </li>
                  )}
                  <li className="list-none p-2 hover:bg-navhover rounded-md">
                    <Link
                      to="#!"
                      className="text-xs 2xl:text-sm"
                      onClick={logOut}
                    >
                      Logout
                    </Link>
                  </li>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
